import React from 'react';
import Avatar from '../avatar/Avatar';
import SocialList from '../social/SocialLists';
import './LeftSide.scss';

const LeftSide = () => (
    <>
        <div className="col-12 col-md-6 left-back d-flex align-items-center">
            <div className="d-flex flex-column align-items-center">
                <Avatar margin />
                <div className="d-flex justify-content-center flex-wrap align-items-baseline">
                    <p className="o-font-lg text-white mb-1 mb-sm-3">WELCOME</p>
                    <h1 className="o-font-lg ml-2 o-text-purple">😼</h1>
                </div>
                <p className="text-center text-white">ini adalah website official milik gua, grey. Gua adalah owner asli dari KuroBotz, salam kenal..!!</p>
                <SocialList margin />
                <div className="row mb-5 justify-content-center">
                    <a href="https://wa.me/6289637196946" className="d-block m-3 text-white o-btn text-center py-2 position-relative">KUROBOTZ</a>
                    <a href="https://chat.whatsapp.com/GMKCDy07dzX6o2T040NpAd" className="d-block m-3 text-white o-btn text-center py-2 position-relative">GROUP</a>
                </div>
            </div>
        </div>
    </>
);

export default LeftSide;